import React from 'react'
import styles from './loginPrompt.module.css'
export const LoginPrompt = () => {
    return (
        <div className={`page ${styles.page}`}>Please Login</div>
    )
}
